import { Link, Tooltip, Typography } from '@mui/material';
import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { Restricted } from '@procureai/permissions-ui';

import { SvbrgCatalogueItem } from '@/generated/gql/graphql';
import { FeatureFlag } from '~/common/types';

export type ContentBlockCell = {
  manufacturer: string;
  name: string;
  link?: string;
};

interface ProductCellProps<R extends GridValidRowModel = ContentBlockCell> {
  row: R;
}

export const ProductCell = <R extends GridValidRowModel = SvbrgCatalogueItem>({ row }: ProductCellProps<R>) => {
  const { name, manufacturer, punchoutUrl } = row;

  return (
    <div>
      <Typography variant="body2" color="textSecondary">
        {manufacturer}
      </Typography>
      <Tooltip title={name}>
        <span>
          <Restricted
            needs={{
              feature: FeatureFlag.ENABLE_CATALOG_PUNCHOUT_LINKS,
            }}
            fallback={
              <Typography variant="body2" color="textPrimary">
                {name}
              </Typography>
            }
          >
            <Link href={punchoutUrl} variant="body2" target="_blank" color="textPrimary">
              {name}
            </Link>
          </Restricted>
        </span>
      </Tooltip>
    </div>
  );
};
